var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.name},[(_vm.titleSuffix)?_c('vue-headful',{key:_vm.tenantName,attrs:{"title":_vm.tenantName + ' - ' + _vm.titleSuffix}}):_c('vue-headful',{key:_vm.tenantName,attrs:{"title":_vm.tenantName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }